function primerProducto(nodo: any): any {
  if (!nodo) {
    return null;
  }
  if (Array.isArray(nodo)) {
    return nodo[0] || null;
  }
  const clave = Object.keys(nodo)[0];
  return clave ? primerProducto(nodo[clave]) : null;
}

export function selectorFamiliaPdf(familia: string): string {
  return `[data-familia="${CSS.escape(familia)}"]`;
}

export function seccionPdf(contenedor: HTMLElement, familia: string, listado: any): HTMLElement {
  const existente = contenedor.querySelector(selectorFamiliaPdf(familia)) as HTMLElement | null;
  if (existente) {
    return existente;
  }

  const seccion = document.createElement('div');
  seccion.dataset.familia = familia;
  seccion.className = 'd-flex flex-column justify-content-start align-items-center';
  const muestra = primerProducto(listado ? listado[familia] : null);
  const destacada = !!(muestra && (muestra.familia_destacada === 1 || muestra.familia_destacada === true || muestra.familia_destacada === '1'));
  const orden = muestra && muestra.orden_familia != null ? Number(muestra.orden_familia) : 100;

  if (destacada) {
    seccion.dataset.destacada = '1';
    seccion.dataset.orden = String(orden);
    const previas = Array.from(contenedor.querySelectorAll('[data-destacada="1"]'));
    let ancla: Element | null = contenedor.querySelector('[data-familia="Limpieza"]');
    for (const previa of previas) {
      const ordenPrevia = Number((previa as HTMLElement).dataset.orden || 100);
      if (orden < ordenPrevia) {
        ancla = previa;
        break;
      }
    }
    if (ancla) {
      contenedor.insertBefore(seccion, ancla);
    } else {
      contenedor.appendChild(seccion);
    }
  } else {
    contenedor.appendChild(seccion);
  }

  return seccion;
}
